module.exports = __webpack_public_path__ + "static/blog-vignette-0d1522dda5298577a35a2aba69879c27.png";